// at top of file
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Watches the hash router path and updates <title>
export default function TitleManager() {
    const { pathname } = useLocation();        // e.g. "/mcp", "/dashboard", etc.
    const defaultTitleRef = useRef(document.title); // capture the <title> from index.html once

    function makeFaviconMCP(color = "#facc15") {
        const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none"
           stroke="${color}" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"/>
        <path d="m2 22 3-3"/>
        <path d="M7.5 13.5 10 11"/>
        <path d="M10.5 16.5 13 14"/>
        <path d="m18 3-4 4h6l-4 4"/>
      </svg>
    `;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    }
    function makeFaviconMail(color = "#2563eb") {
        const svg = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none"
               stroke="${color}" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"
               class="lucide lucide-mail">
            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/>
            <rect x="2" y="4" width="20" height="16" rx="2"/>
          </svg>
        `;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    }

    useEffect(() => {
        let link = document.getElementById("dynamic-favicon") as HTMLLinkElement | null;
        if (!link) {
            link = document.createElement("link");
            link.id = "dynamic-favicon";
            link.rel = "icon";
            document.head.appendChild(link);
        }

        if (pathname === "/mcp" || pathname === "/mcpOrchestrator") {
            document.title = "MCP Orchestrator";
            link.href = makeFaviconMCP("#2563eb");
        } else if (pathname === "/" || pathname === "/emailtracker" || pathname === "/dashboard") {
            document.title = "Email Tracker";
            link.href = makeFaviconMail("#2563eb");
        } else {
            document.title = defaultTitleRef.current;
            link.href = '/favicon.ico';
        }
    }, [pathname]);

    return null;
}
